import { OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { DBConnectorService } from './service/test.service';
import { UserIdleService } from 'angular-user-idle';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'
  ]
})
export class AppComponent implements OnInit, AfterViewChecked {
  UserCheck: any = {};
  username: string;
  showLoader: boolean;

  constructor(
    private msalService: MsalService,
    private router: Router,
    private dbconnectorService: DBConnectorService,
    private http: HttpClient,
    private userIdle: UserIdleService,
    private cdref: ChangeDetectorRef
  ) {
    //changes chandra
    // this.adalService.init(this.secretService.adalConfig);
    // this.adalService.handleWindowCallback();
    // this.adalService.getUser();
    //changes chandra

    // this.ReadJsonConfig()
    //   .subscribe((config) => {
    //     // do stuff with the config
    //     // console.log("Config:" + JSON.stringify(config))
    //     this.secretService.config = config;
    //     this.adalService.init(this.secretService.adalConfig);
    //     this.adalService.handleWindowCallback();
    //     this.adalService.getUser();

    //   }
    //   );
  }

  ReadJsonConfig() {
    return this.http.get('/config.json')
      // return this.http.get('/api/Dropdown/config')
  }


  ngOnInit(): void {
    this.showLoader = true;
    this.msalService.instance.handleRedirectPromise().then(
      resultSuccess => {        
        this.showLoader = false;
        if(resultSuccess && resultSuccess.account) {
          this.msalService.instance.setActiveAccount(resultSuccess.account)
          // sessionStorage.setItem('msalToken', resultSuccess.accessToken)
        }
      },
      resultFailed => {        
        this.showLoader = false;
        console.log(resultFailed)
      }
    )
    .catch(ex => {              
      this.showLoader = false;
      console.error(ex)
    }
    )

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });

    // Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => { });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => { console.log('Time is up!'); this.msalService.logout(); });
    const that = this;
    setTimeout(function () { that.msalService.logout(); }, 28800000);

  }

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }

}
